import { BoardScene } from "./../BoardScene";
import { GameConstants } from "./../../../GameConstants";
import { GameVars } from "../../../GameVars";
import { AudioManager } from "../../../AudioManager";

export class RouletteLayer extends Phaser.GameObjects.Container {

    private scaledItemsContainer: Phaser.GameObjects.Container;

    private spin: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene) {

        super(scene);

        const darkLayer = new Phaser.GameObjects.Graphics(this.scene);
        darkLayer.fillStyle(0x495471, .7);
        darkLayer.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        darkLayer.setInteractive(new Phaser.Geom.Rectangle(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT), Phaser.Geom.Rectangle.Contains);
        darkLayer.on("pointerdown", () => {
            //
        }, this);
        this.add(darkLayer);

        this.scaledItemsContainer = new Phaser.GameObjects.Container(this.scene);
        this.scaledItemsContainer.x = GameConstants.GAME_WIDTH / 2;
        this.scaledItemsContainer.y = GameConstants.GAME_HEIGHT / 2;
        this.scaledItemsContainer.scaleX = GameVars.scaleX;
        this.add(this.scaledItemsContainer);

        let backgournd = new Phaser.GameObjects.Image(this.scene, 0, 5, "texture_atlas_1", "layout_base");
        backgournd.setScale(1, 1.35);
        this.scaledItemsContainer.add(backgournd);

        this.spin = new Phaser.GameObjects.Image(this.scene, 0, 5, "texture_atlas_1", "roulette_spin");
        this.scaledItemsContainer.add(this.spin);

        let roulette = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "roulette_frame");
        this.scaledItemsContainer.add(roulette);

        this.scaledItemsContainer.alpha = 0;

        this.scene.tweens.add({
            targets: this.scaledItemsContainer,
            alpha: 1,
            ease: Phaser.Math.Easing.Quadratic.Out,
            duration: 500
        });

        let extraAngle = (Math.random() * 30 + 10) * (GameVars.currentTurn === GameConstants.PLAYER ? 1 : -1);

        this.scene.tweens.add({
            targets: this.spin,
            angle: 360,
            ease: Phaser.Math.Easing.Quadratic.In,
            duration: 750,
            delay: 1000,
            onComplete: () => {
                this.scene.tweens.add({
                    targets: this.spin,
                    angle: this.spin.angle + 360,
                    ease: Phaser.Math.Easing.Linear.Linear,
                    duration: 500,
                    repeat: 2,
                    onComplete: () => {
                        this.scene.tweens.add({
                            targets: this.spin,
                            angle: this.spin.angle + 1080 + extraAngle,
                            ease: Phaser.Math.Easing.Quadratic.Out,
                            duration: 2750,
                            onComplete: () => {
                                this.scene.time.addEvent({ delay: 1000, callback: () => { 
                                    BoardScene.currentInstance.startMatch();
                                }, callbackScope: this});
                            },
                            onCompleteScope: this
                        });
                    },
                    onCompleteScope: this
                });
            },
            onCompleteScope: this,
            onStart: () => {
                AudioManager.playSound("wheel_spin_stops");
            },
            onStartScope: this
        }); 
    }

    public destroy(): void {

        this.scene.tweens.add({
            targets: this,
            alpha: 0,
            ease: Phaser.Math.Easing.Quadratic.Out,
            duration: 500,
            onComplete: () => {
                super.destroy();
            },
            onCompleteScope: this
        });
    }
}
